import React, { useState, useEffect } from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import { sendReminderApi, postJobMessageApi } from '../../API/API'
import styles from '../ProfileDeatailForInternalExternal/InviteTalentModal/InviteTalentModal.module.css'
import SelectJobModal from '../QueryPage/components/organisms/SelectJobModal'
import { ReactComponent as SelectJobIcon } from '../../assets/icons/SelectJobIcon.svg'
import ReminderEmailPreviewTemplate from './ReminderEmailPreviewTemplate'
import ReminderSmsPreviewTemplate from './ReminderSmsPreviewTemplate'
import ReminderWhatsAppPreviewTemplate from './ReminderWhatsAppPreviewTemplate'

const METHODS = ['Email', 'SMS', 'WhatsApp']

const asArray = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean)
  return value ? [value] : []
}

const getEmails = (item) =>
  asArray(
    item?.emails ||
      item?.Emails ||
      item?.invitedEmail ||
      item?.email ||
      item?.Email ||
      item?.EmailAddress ||
      item?.account?.emailAddress,
  )

const getPhones = (item) =>
  asArray(
    item?.phones ||
      item?.Phones ||
      item?.phone ||
      item?.Phone ||
      item?.MobilePhone ||
      item?.account?.mobilePhone,
  )

const EditPencilIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.69725 16.5767H2.80325L14.2985 5.1065L13.2045 4.0065L1.69725 15.4827V16.5767ZM0.85175 18.28C0.607083 18.28 0.404 18.1992 0.2425 18.0375C0.0808334 17.876 0 17.6729 0 17.4283V15.5077C0 15.2797 0.0466668 15.057 0.14 14.8395C0.233333 14.6218 0.356584 14.4364 0.50975 14.2832L14.363 0.448999C14.5003 0.307666 14.6657 0.1975 14.859 0.1185C15.0523 0.0394998 15.253 0 15.461 0C15.6522 0 15.8434 0.0394998 16.0347 0.1185C16.2261 0.1975 16.4028 0.305666 16.5647 0.442999L17.862 1.72225C18.016 1.88425 18.1283 2.06192 18.199 2.25525C18.2697 2.44858 18.305 2.64283 18.305 2.838C18.305 3.03333 18.2655 3.23083 18.1865 3.4305C18.1075 3.63017 17.9993 3.80067 17.862 3.942L4.00875 17.7702C3.85142 17.9234 3.665 18.0467 3.4495 18.14C3.234 18.2333 3.01225 18.28 2.78425 18.28H0.85175ZM13.7545 4.5505L13.2045 4.0065L14.2985 5.1065L13.7545 4.5505Z" fill="#16191C"/>
  </svg>
)

const SendReminderModal = ({ item, onClose, onSent, hideTemplateSelect = false }) => {
  const companyProfileResp = useSelector((state) => state.getCompanyProfileDetailsReducer.resp)
  const localProfiles = JSON.parse(localStorage.getItem('userProfile') || '{}')?.Profiles || {}
  const companyName =
    companyProfileResp?.companyProfile?.CompanyName ||
    companyProfileResp?.Profiles?.CompanyName ||
    localProfiles?.CompanyName ||
    ''

  const fullName = (
    item?.profileName ||
    item?.talentName ||
    item?.TalentName ||
    item?.fullName ||
    item?.name ||
    item?.users?.Profiles?.FullName ||
    ''
  ).trim()
  const splitName = fullName.split(/\s+/).filter(Boolean)
  const fn = item?.users?.Profiles?.FirstName || item?.FirstName || splitName[0] || ''
  const ln =
    item?.users?.Profiles?.LastName ||
    item?.LastName ||
    (splitName.length > 1 ? splitName.slice(1).join(' ') : '')
  const name     = `${fn} ${ln}`.trim() || fullName || 'Talent'
  const role     = item?.talentTitle || item?.Title || item?.title || item?.jobTitle || ''
  const picture  = item?.users?.Profiles?.PictureUrl || item?.profilePictureUrl || item?.pictureUrl
  const initials = `${fn[0] || ''}${ln[0] || ''}`.toUpperCase() || '?'
  const bgColor  = item?.avatarColor || '#9ba5b0'
  const [selectedJob, setSelectedJob] = useState(null)
  const preselectedJobId = item?.jobId || item?.JobId || item?.InvitedBy?.[0]?.JobId
  const preselectedJobTitle = item?.jobTitle || item?.JobTitle || item?.InvitedBy?.[0]?.jobTitle
  const preselectedJob = preselectedJobId ? { jobId: preselectedJobId, jobTitle: preselectedJobTitle } : null

  const jobDetails = selectedJob
    ? [
        { label: 'Title', value: selectedJob.title },
        { label: 'Job Type', value: selectedJob.type },
        { label: 'Start Date', value: selectedJob.startDate },
        { label: 'Location', value: selectedJob.location },
        { label: 'Skills', value: selectedJob.skills },
      ].filter((detail) => detail.value)
    : []
  const [jobModalOpen, setJobModalOpen] = useState(false)
  const jobTitle = selectedJob?.title || ''

  const sentReminderCount = item?.reminderCount ?? item?.ReminderCount ?? 0
  const nextReminderNumber = Math.min(sentReminderCount + 1, 3)
  const [selectedTemplate, setSelectedTemplate] = useState(`Template ${nextReminderNumber}`)
  const reminderNumber = Number(selectedTemplate.split(' ')[1]) || 1

  const emails = getEmails(item)
  const phones = getPhones(item)

  const [selectedMethods, setSelectedMethods] = useState(['Email'])
  const [selectedEmails, setSelectedEmails] = useState(() => (emails.length ? [emails[0]] : []))
  const [selectedSmsPhones, setSelectedSmsPhones] = useState(() => (phones.length ? [phones[0]] : []))
  const [selectedWhatsappPhones, setSelectedWhatsappPhones] = useState(() => (phones.length ? [phones[0]] : []))
  const [expandedSections, setExpandedSections] = useState({ email: true, sms: true, whatsapp: true })
  const [previewChannel, setPreviewChannel]   = useState('email')
  const [message, setMessage]                 = useState(
    `Hi ${fn || 'Talent'},\n\nThis is a reminder regarding your invite. Please review and respond at your earliest convenience.`
  )
  const [isSending, setIsSending] = useState(false)
  const [isAiLoading, setIsAiLoading] = useState(false)
  const [sent, setSent]           = useState(false)
  const [avatarError, setAvatarError] = useState(false)

  const showAvatar = Boolean(picture) && !avatarError

  const toggleMethod = (method) => {
    setSelectedMethods((prev) =>
      prev.includes(method) ? prev.filter((m) => m !== method) : [...prev, method]
    )
  }

  const toggleSelectionItem = (setList, value) => {
    setList((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    )
  }

  const toggleSelectAll = (items, list, setList) => {
    setList(list.length === items.length ? [] : [...items])
  }

  const toggleSectionExpanded = (key) => {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }))
  }

  const getCreditAlertText = (methods) => {
    if (methods.length === 0) return ''

    const parts = []
    if (methods.includes('Email')) parts.push('0.5 credit per email')

    const hasSms = methods.includes('SMS')
    const hasWhatsApp = methods.includes('WhatsApp')
    if (hasSms && hasWhatsApp) {
      parts.push('1 credit each for SMS and WhatsApp messages')
    } else if (hasSms) {
      parts.push('1 credit for SMS')
    } else if (hasWhatsApp) {
      parts.push('1 credit for WhatsApp')
    }

    if (parts.length === 0) return ''
    return `You'll be charged ${parts.join(' and ')}.`
  }

  useEffect(() => {
    const lower = selectedMethods.map((m) => m.toLowerCase())
    if (!lower.includes(previewChannel) && lower.length > 0) {
      setPreviewChannel(lower[0])
    }
  }, [selectedMethods])

  useEffect(() => {
    if (emails.length) {
      setSelectedEmails((prev) => {
        const filtered = prev.filter((v) => emails.includes(v))
        return filtered.length ? filtered : [emails[0]]
      })
    }
  }, [emails.join('|')])

  useEffect(() => {
    if (phones.length) {
      setSelectedSmsPhones((prev) => {
        const filtered = prev.filter((v) => phones.includes(v))
        return filtered.length ? filtered : [phones[0]]
      })
      setSelectedWhatsappPhones((prev) => {
        const filtered = prev.filter((v) => phones.includes(v))
        return filtered.length ? filtered : [phones[0]]
      })
    }
  }, [phones.join('|')])

  const renderSelectionSection = ({ key, title, items, selected, setSelected, creditLabel }) => {
    if (!items || items.length < 1) return null
    const hasMultiple = items.length > 1
    const expanded = hasMultiple ? expandedSections[key] : true
    const allSelected = selected.length === items.length && items.length > 0
    return (
      <div className={styles.selectionSection}>
        <div className={styles.selectionHeader}>
          <span className={styles.selectionTitle}>
            {title} <span className={styles.selectionCount}>{selected.length}/{items.length}</span>
          </span>
          {hasMultiple && (
            <div className={styles.selectionHeaderRight}>
              <input
                type="checkbox"
                className={styles.selectionMasterCheckbox}
                checked={allSelected}
                onChange={() => toggleSelectAll(items, selected, setSelected)}
                aria-label={`Select all ${title}`}
              />
              <button
                type="button"
                className={styles.selectionChevron}
                onClick={() => toggleSectionExpanded(key)}
                aria-label={expanded ? 'Collapse' : 'Expand'}
              >
                {expanded ? '▲' : '▼'}
              </button>
            </div>
          )}
        </div>
        {expanded && (
          <div className={styles.selectionList}>
            {items.map((value, i) => (
              <label key={`${key}-${i}`} className={styles.selectionRow}>
                <span className={styles.selectionRowLeft}>
                  {hasMultiple && (
                    <input
                      type="checkbox"
                      checked={selected.includes(value)}
                      onChange={() => toggleSelectionItem(setSelected, value)}
                    />
                  )}
                  {value}
                </span>
                <span className={styles.selectionCredit}>{creditLabel}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    )
  }

  const emailSelectionValid = !selectedMethods.includes('Email') || selectedEmails.length > 0
  const smsSelectionValid = !selectedMethods.includes('SMS') || selectedSmsPhones.length > 0
  const whatsappSelectionValid =
    !selectedMethods.includes('WhatsApp') || selectedWhatsappPhones.length > 0

  const handleWriteWithAi = async () => {
    if (selectedJob?.JobOrderId) {
      try {
        setIsAiLoading(true)
        const id = item?.profileId || item?.SkillListingId || item?._id
        const response = await postJobMessageApi(selectedJob.JobOrderId, id)
        const aiMessage = response?.data?.data?.message
        if (aiMessage) {
          setMessage(aiMessage)
        }
      } catch (e) {
        // silently ignore
      } finally {
        setIsAiLoading(false)
      }
    }
  }

  const handleSend = async () => {
    if (isSending) return
    const id = item?.profileId || item?.SkillListingId || item?._id
    if (!id) return
    try {
      setIsSending(true)
      const jobId = preselectedJobId || selectedJob?.id || selectedJob?.jobId
      await sendReminderApi(
        {
          medium: selectedMethods.map((m) => m.toLowerCase()),
          jobId,
          message,
          template: selectedTemplate,
          ...(selectedMethods.includes('Email') && { email: selectedEmails }),
          ...(selectedMethods.includes('SMS') && { sms: selectedSmsPhones }),
          ...(selectedMethods.includes('WhatsApp') && { whatsapp: selectedWhatsappPhones }),
        },
        id,
      )
      setSent(true)
      onSent?.()
      setTimeout(onClose, 1500)
    } catch (e) {
      // silently ignore
    } finally {
      setIsSending(false)
    }
  }

  const isSendDisabled =
    !selectedJob ||
    selectedMethods.length === 0 ||
    !message.trim() ||
    isSending ||
    !emailSelectionValid ||
    !smsSelectionValid ||
    !whatsappSelectionValid

  useEffect(() => {
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = prev }
  }, [])

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        style={jobModalOpen ? { display: 'none' } : undefined}
      >

        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.modalTitle}>Send Reminder ({reminderNumber}/3)</h2>
          <button type="button" className={styles.closeBtn} onClick={onClose}>×</button>
        </div>
        <div className={styles.headerDivider} />

        <div className={styles.shell}>
          <div className={styles.grid}>

            {/* Left card */}
            <div className={styles.card}>

              {/* Candidate */}
              <div className={styles.candidateRow}>
                <div className={styles.candidateLeft}>
                  {showAvatar ? (
                    <img
                      src={picture}
                      alt={name}
                      className={styles.candidateAvatar}
                      onError={() => setAvatarError(true)}
                    />
                  ) : (
                    <div
                      className={styles.candidateAvatarFallback}
                      style={{ background: bgColor }}
                    >
                      {initials}
                    </div>
                  )}
                  <span className={styles.onlineDot} />
                </div>
                <div className={styles.candidateMid}>
                  <div className={styles.candidateName}>{name}</div>
                  <div className={styles.candidateRole}>{role}</div>
                </div>
                <div className={styles.candidateBadges}>
                  <div className={styles.externalMiniBadge}>External</div>
                </div>
              </div>

              {/* Select Job */}
              <div className={styles.field}>
                <label className={styles.fieldLabel}>Select Job</label>
                <button
                  type="button"
                  className={`${styles.selectJobBtn} ${selectedJob ? styles.selectJobBtnFilled : ''}`}
                  onClick={() => !preselectedJob && setJobModalOpen(true)}
                  disabled={Boolean(preselectedJob)}
                >
                  {selectedJob ? (
                    <>
                      <div className={styles.selectJobCopy}>
                        <div className={styles.selectJobTitle}>{selectedJob.title}</div>
                        {selectedJob?.location && <div className={styles.selectJobMeta}>{selectedJob.location}</div>}
                      </div>
                      {!preselectedJob && (
                        <span className={styles.editIcon} aria-hidden="true">
                          <EditPencilIcon />
                        </span>
                      )}
                    </>
                  ) : (
                    <div className={styles.selectJobEmpty}>
                      <span className={styles.selectJobEmptyIcon}><SelectJobIcon /></span>
                      <span>Select a Job</span>
                    </div>
                  )}
                </button>
              </div>

              {/* Channel selection */}
              <div className={styles.field}>
                <label className={styles.fieldLabel}>
                  How you want to invite? <span className={styles.required}>*</span>
                </label>
                <div className={styles.methodChips}>
                  {METHODS.map((method) => {
                    const active = selectedMethods.includes(method)
                    return (
                      <button
                        key={method}
                        type="button"
                        className={`${styles.methodChip} ${active ? styles.methodChipActive : ''}`}
                        onClick={() => toggleMethod(method)}
                      >
                        <span className={styles.methodChipIcon}>{active ? '×' : '+'}</span>
                        {method}
                      </button>
                    )
                  })}
                </div>
                {getCreditAlertText(selectedMethods) && (
                  <div className={styles.creditAlert}>
                    <span className={styles.creditAlertIcon} aria-hidden="true">⚡</span>
                    {getCreditAlertText(selectedMethods)}
                  </div>
                )}

                {selectedMethods.includes('Email') &&
                  renderSelectionSection({
                    key: 'email',
                    title: 'Select Email',
                    items: emails,
                    selected: selectedEmails,
                    setSelected: setSelectedEmails,
                    creditLabel: '0.5 credit',
                  })}

                {selectedMethods.includes('SMS') &&
                  renderSelectionSection({
                    key: 'sms',
                    title: 'Select Phone Number',
                    items: phones,
                    selected: selectedSmsPhones,
                    setSelected: setSelectedSmsPhones,
                    creditLabel: '1 credit',
                  })}

                {selectedMethods.includes('WhatsApp') &&
                  renderSelectionSection({
                    key: 'whatsapp',
                    title: 'Select WhatsApp',
                    items: phones,
                    selected: selectedWhatsappPhones,
                    setSelected: setSelectedWhatsappPhones,
                    creditLabel: '1 credit',
                  })}
              </div>

              {/* Template */}
              {!hideTemplateSelect && (
                <div className={styles.field}>
                  <label className={styles.fieldLabel}>Message Template</label>
                  <div className={styles.selectWrap}>
                    <select
                      className={styles.select}
                      value={selectedTemplate}
                      onChange={(e) => setSelectedTemplate(e.target.value)}
                    >
                      {['Template 1', 'Template 2', 'Template 3'].map((tpl) => (
                        <option key={tpl} value={tpl}>{tpl}</option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {/* Message */}
              <div className={styles.field}>
                <div className={styles.fieldTopRow}>
                  <label className={styles.fieldLabel}>
                    Write Message For Talent <span className={styles.required}>*</span>
                  </label>
                  <button type="button" className={styles.aiBtn} onClick={handleWriteWithAi} disabled={!selectedJob || isAiLoading}>
                    <span className={styles.aiIcon}>✦</span> Write with AI
                  </button>
                </div>
                <div className={styles.textareaWrap} style={{ position: 'relative' }}>
                  {isAiLoading && (
                    <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.7)', zIndex: 1, borderRadius: 8 }}>
                      <Spin size="default" />
                    </div>
                  )}
                  <textarea
                    className={styles.textarea}
                    rows={5}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Write a reminder message for the talent."
                  />
                </div>
                <div style={{ textAlign: 'right', fontSize: 11, color: '#b0b9c3', marginTop: 4 }}>
                  {message.length}/500
                </div>
              </div>
            </div>

            {/* Right preview card */}
            <div className={`${styles.card} ${styles.previewCard}`}>
              <div className={styles.previewTitle}>Preview Template</div>
              <div className={styles.tabs}>
                {[
                  { key: 'email', label: 'Email' },
                  { key: 'whatsapp', label: 'WhatsApp' },
                  { key: 'sms', label: 'SMS' },
                ]
                  .filter((tab) => selectedMethods.map((m) => m.toLowerCase()).includes(tab.key))
                  .map((tab) => (
                    <button
                      key={tab.key}
                      type="button"
                      className={`${styles.tabBtn} ${previewChannel === tab.key ? styles.tabActive : ''}`}
                      onClick={() => setPreviewChannel(tab.key)}
                    >
                      {tab.label}
                    </button>
                  ))}
              </div>

              <div className={styles.previewCenter}>
                <div className={styles.phoneFrame}>
                  <div className={styles.phoneTopBar}>
                    <span>13:13</span>
                    <span className={styles.phonePill} />
                  </div>
                  <div className={styles.phoneContent}>
                    {previewChannel === 'email' && (
                      <ReminderEmailPreviewTemplate
                        talentFirstName={fn || 'Talent'}
                        jobTitle={jobTitle}
                        selectedJob={selectedJob}
                        message={message}
                        companyName={companyName}
                        selectedTemplate={selectedTemplate}
                      />
                    )}
                    {previewChannel === 'sms' && (
                      <ReminderSmsPreviewTemplate
                        talentFirstName={fn || 'Talent'}
                        jobTitle={jobTitle}
                        jobDetails={jobDetails}
                        message={message}
                        companyName={companyName}
                        selectedTemplate={selectedTemplate}
                      />
                    )}
                    {previewChannel === 'whatsapp' && (
                      <ReminderWhatsAppPreviewTemplate
                        talentFirstName={fn || 'Talent'}
                        jobTitle={jobTitle}
                        jobDetails={jobDetails}
                        message={message}
                        selectedTemplate={selectedTemplate}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <button
            type="button"
            className={styles.sendBtn}
            disabled={isSendDisabled}
            onClick={handleSend}
          >
            {isSending ? (
              <Spin size="small" style={{ marginRight: 8 }} />
            ) : sent ? (
              'Reminder Sent!'
            ) : (
              <>Send Reminder <span className={styles.sendArrow}>▶</span></>
            )}
          </button>
        </div>

        <SelectJobModal
          open={jobModalOpen}
          onClose={() => setJobModalOpen(false)}
          onSelect={(job) => {
            setSelectedJob(job)
            setJobModalOpen(false)
          }}
          autoSelectJob={preselectedJob}
          zIndex={100100}
        />

      </div>
    </div>
  )
}

export default SendReminderModal
